<template>
    <div id="bankTransferList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>

        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                  <div class="page-title"> Debt Notes List</div>
                  <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                  <router-link v-if="canAddDebtNote == true" class="btn btn-primary pull-right" v-bind:to="{name: 'DebtNoteCreate'}"> <i class="fp-add"> </i> Add</router-link>
                  <a href="javascript:void(0)" class="btn btn-secondary pull-right mr-2" v-on:click="exportCheck()">
                      <i class="fp-export"></i> Export
                  </a>
                   <a href="javascript:void(0)" class="btn btn-secondary pull-right mr-2" v-on:click="openModal()">
                      <i class="fp-export"></i> Import
                  </a>

                </div>


                <div class="container-fluid">
                    <div class="admin-page-content">
                        <data-table-filter-config :moduleName="'debtNoteList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <div class="data-table bg-white overflow-hidden">
                          <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>

                          <p v-if="batchProcess1" class="alert-success p-2" id="processFetchBatchMsg1">Current batch {{batchNum1}} is processing please wait!</p>
                            <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                          <section class="data-table bg-white">
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange" :moduleName="'debtNoteList'" :position="'top'">
                                  </custom-pagination>

                                  <vue-good-table
                                      ref="debtNoteListTable"
                                      mode="remote"
                                      title="Debt Notes"
                                      @on-page-change="onPageChange"
                                      @on-selected-rows-change="selectionChanged"
                                      @on-column-filter="onColumnFilter"
                                      @on-per-page-change="onPerPageChange"
                                      @on-sort-change="onSortChange"
                                      :totalRows="totalRecords"
                                      :columns="userColumns"
                                      :rows="rows"
                                      :pagination-options="{
                                          enabled: false,
                                          position: 'bottom',
                                          perPage: perPage,
                                          perPageDropdown:dropDownPerPage,
                                          dropdownAllowAll: false,
                                      }"
                                      :select-options="{
                                        enabled: true,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                      }"
                                      :search-options="{
                                      enabled: false,
                                      }">

                                      <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                          <div :key="key">

                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="props.row.intereset_rate_type == 'Variable' || (props.row.status != 'Active' && props.row.status != 'Closed') && canAddDebtNote == true">
                                                    <router-link title="Edit Debt Note" class="fp-edit" v-bind:to="{name: 'DebtNoteEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                                <template>
                                                    <span v-if="props.row.intereset_rate_type == 'Variable' || (props.row.status != 'Active' && props.row.status != 'Closed')">&nbsp;|&nbsp;</span>
                                                    <router-link title="View Debt Note Interest" class="fp-view" v-bind:to="{name: 'DebtNoteInteresetView',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else-if="props.column.field == 'note_amount' || props.column.field == 'principal_payment' || props.column.field == 'interest'
                                            || props.column.field == 'current_balance'">
                                                <div style="text-align: right;">
                                                  {{props.formattedRow[props.column.field]}}
                                                </div>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                          </div>
                                      </template>

                                      <div slot="selected-row-actions">
                                          <button v-if="isCloseStatus" id="reverseDebtNoteBtn" v-on:click.prevent="reverseDebtNote" class="btn btn-primary">Reverse</button>
                                          <button v-if="isActivateStatus" id="activeDebtNoteBtn" v-on:click.prevent="activateDebtNote" class="btn btn-primary">Active</button>
                                          <button id="deleteDebtNoteBtn" v-on:click.prevent="deleteDebtNote" class="btn btn-primary">Delete</button>
                                      </div>

                                  </vue-good-table>
                                  <custom-pagination
                                          :page-changed="onPageChange"
                                          :per-page-changed="onPerPageChange">
                                  </custom-pagination>
                          </section>
                          <div class="modal fade policy-modal" id="debt-note-modal" ref="debt-note-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="debt-note-modal" aria-hidden="true">
                                <div class="modal-dialog" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h5 class="modal-title">Select File</h5>
                                        </div>
                                        <div class="modal-body">
                                            <form id="importFile" class="addinspectionForm">
                                                <div class="form-row">
                                                    <div class="col form-group">
                                                        <label class="control-label require mb-2" for="name">File:</label><br/>
                                                        <input id="dnFile" type="file" @change="onFileChanged">
                                                        <div class="field-error">{{import_error}}</div>
                                                    </div>
                                                </div>
                                                <div class="form-row">
                                                    <div class="col form-group" v-if="fileName != ''">
                                                        <label class="control-label"> Download Sample file </label>
                                                        <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                    </div>
                                                </div>
                                                <p>&nbsp;</p>
                                                <p>&nbsp;</p>
                                                <template v-if="importIssue.duplicate && importIssue.duplicate.length > 0">
                                                    <label class="d-block"> Debt Note Not Imported For These Unit due to having same Debt note open:</label>
                                                    <template v-for="(db,perKey) in importIssue.duplicate">
                                                        <a :key="perKey" v-if="perKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="perKey">{{db.asset_number}}</span>
                                                    </template>
                                                    <p>&nbsp;</p>
                                                </template>
                                                <template v-if="importIssue.asset && importIssue.asset.length > 0">
                                                    <label class="d-block"> Debt Note Not Imported For These Unit as unit not found in system:</label>
                                                    <template v-for="(dba,perAKey) in importIssue.asset">
                                                        <a :key="perAKey" v-if="perAKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="perAKey">{{dba.asset_number}}</span>
                                                    </template>
                                                    <p>&nbsp;</p>
                                                </template>
                                                <template v-if="importIssue.vendor && importIssue.vendor.length > 0">
                                                    <label class="d-block"> Debt Note Not Imported For These Reference as vendor not found in system:</label>
                                                    <template v-for="(dbv,perVKey) in importIssue.vendor">
                                                        <a :key="perVKey" v-if="perVKey > 0"> &nbsp;&nbsp; | &nbsp;</a><span :key="perVKey">{{dbv.reference_number}}</span>
                                                    </template>
                                                    <p>&nbsp;</p>
                                                </template>
                                            </form>

                                            <div class="modal-footer">
                                                <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                                <button class="btn btn-primary" id="importButton" v-on:click="importDebtNote()"> <i class="fp-import"> </i> Import</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>

<script>

import Vue from 'vue';
import EventBus from ".././event-bus";

import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import VueSSE from 'vue-sse'
Vue.use(VueSSE);
let msgServer;
export default {
    name: "debtNoteList",
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: "Debt Notes List | " +process.env.COPYRIGHT_NAME
    },
    mixins:[commonMixins,dataTableMixins],
    data: () => ({
      isActivateStatus: false,
      permissions:[],
      cantAccessPage:'',
      canAddDebtNote:'',
      loading:false,
      userColumns: [],
      columns: [
            {
                label: 'Actions',
                field: 'action',
                sortable: false,
                hidden:false,
            },
            {
                label: 'Asset',
                field: 'asset_number',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Asset", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Financier',
                field: 'vendor_name',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Financier", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Reference Number',
                field: 'reference_number',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Reference Number", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Note Amount',
                field: 'note_amount',
                fpFieldType:"integer",
                type:"number",
                // thClass: "text-Right", //this.alignment,
                html: true,
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Note Amount", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Start Date',
                field: 'financing_start_date',
                fpFieldType:"date",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Start Date", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Duration',
                field: 'duration',
                fpFieldType:"text",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Duration", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                    label: 'Status',
                    field: 'status',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter", //only trigger on enter not on keyup
                        filterDropdownItems:["Entered","Active","Closed"]
                    }
              },
            {
                label: 'Payment Date',
                field: 'first_principal_payment_date',
                fpFieldType:"date",
                filterable: true,
                hidden: false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "MM/DD/YYYY", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Principal Amount',
                field: 'principal_payment',
                fpFieldType:"integer",
                type:"number",
                filterable: true,
                hidden: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Interest Amount',
                field: 'interest',
                fpFieldType:"integer",
                type:"number",
                filterable: true,
                hidden: true,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
              label: 'Current Balance',
              field: 'current_balance',
              fpFieldType:"integer",
              type:"number",
              filterable: true,
              hidden: true,
              filterOptions: {
                  enabled: false, // enable filter for this column
                  placeholder: "Current Balance", // placeholder for filter input
                  filterValue: '', // initial populated value for this filter
                  trigger: "enter" //only trigger on enter not on keyup
              }
          },
      ],
      rows: [],
      totalRecords: 0,
      pageKey:"_debt_note_list_",
      batchProcess:0,
      batchProcess1:0,
      batchNum:"",
      batchNum1:"",
      selectedFile:'',
      fileName:'',
      import_error:'',
      batchId:0,
      batchError:false,
      importIssue:[],
      isCloseStatus: false,
      selectedRows: [],
    }),
    watch:{
        permissions: function(permission){
            var self = this;
            permission.forEach(function (permissions) {
                if(permissions.name == 'list_debt_notes') {
                    self.cantAccessPage = true;
                }
                if(permissions.name == 'add_debt_note') {
                    self.canAddDebtNote = true;
                }
            });
        }
    },
    created: function() {
    },
    mounted: function () {

        this.getPermissions();
    },
    methods: {

      exportCheck: function() {
          var self = this;
          var count = 0;
          var actionFlag = "";
          var data = this.$refs['debtNoteListTable'].selectedRows;
          count = data.length;

            if(this.serverParams.selectedAll == true){
                actionFlag = "";
            }else if(count != 0 && count <= 100){
                actionFlag = "export";
            }

          this.exportReports(actionFlag);
      },
      openModal: function(){
            var self = this;
            // if (self.batchProcess){
            //     self.$swal('','Previous batch already runnig','info');
            //     return;
            // }
            self.selectedFile = "";
            // self.duplicatePolicy = [];
            $("#dnFile").val('');
            self.import_error = '';
            self.generateExcelSample();
            self.importIssue = [];
            $('#debt-note-modal').modal('show');
        },
        generateExcelSample:function(){
            var self = this;

            $.ajax({
                url:
                process.env.ROOT_API +
                "/debt-note-excel/generate",
                type: "POST",
                crossDomain: true,
                dataType: "json",
                headers: this.ajxHeaders,

                success: function(data) {
                    self.loading = false;
                    self.fileName = data.content.file;
                    self.file = data.content.web;

                },
                error: function(jqXHR, exception) {
                    self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'debt note-import')

                }
            });
        },
        onFileChanged(event) {
            const file = event.target.files[0];
            var self = this;
            self.selectedFile = file;
            self.import_error = '';
        },
        downloadSample(){
            var self = this;
            // alert(self.file);
            var docPath = self.file;
            var save = document.createElement('a');
            save.href = docPath;
            save.download = docPath;
            save.target = '_blank';
            document.body.appendChild(save);
            save.click();
            document.body.removeChild(save);
        },
        checkBatchStatus:function(){
            var self =  this;
            this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
            .then(sse => {
                // Store SSE object at a higher scope
                msgServer = sse;

                // Listen for messages without a specified event
                sse.subscribe('', data => {
                    if ( data.status == "1") {
                        self.batchProcess = false;
                        self.batchProcess1 = false;
                        self.batchNum1 = "";
                        self.loadList();
                        if (data.other_params != '' && data.other_params != null && data.other_params != undefined){
                            self.importIssue = JSON.parse(data.other_params);
                            $('#debt-note-modal').modal('show');
                        }
                        sse.close();
                    }else if (data.status == "2") {
                        self.batchProcess = false;
                        self.batchError = true;
                        self.batchProcess1 = false;
                        self.batchNum1 = "";
                        self.batchErrorMsg = data.message;
                        sse.close();
                    }
                });

            })
            .catch(err => {
                // When this error is caught, it means the initial connection to the
                // events server failed.  No automatic attempts to reconnect will be made.
                console.error('Failed to connect to server', err);
            });

        },
        importDebtNote:function(){
            var self = this;

            self.import_error = "";
            if( self.selectedFile == "" || self.selectedFile == null){
                self.import_error = "Please Select Excel File.";
                return;
            }
            var fileExtension = ['xls', 'xlsx'];
            if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                return;
            }
            console.log(self.selectedFile);

            var formData = new FormData();
            formData.append('myFile', self.selectedFile);

            self.loading = true;

            $.ajax({
                url: process.env.ROOT_API + "/debt-note/import",
                type: "POST",
                data: formData,
                headers: this.ajxHeaders,
                crossDomain: true,
                processData: false,
                contentType: false,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.batch_id){
                        self.batchProcess1 = true;
                        self.batchId = data.batch_id;
                        self.batchNum1 = data.batch;
                        self.checkBatchStatus();
                        $('#debt-note-modal').modal('hide');
                    }
                        self.loadList();

                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    $('#importButton').text('Import');
                    $('#importButton').prop('disabled',false);
                    $('#cancelButton').prop('disabled',false);
                    self.generateStatusCodeMessage(jqXHR,true,'policy-import-error')
                }
            });
        },
      alignment: function() {
        return 'text-right';

      },
      cancelAll: function (cancelAll) {
        this.$refs.debtNoteListTable.unselectAllInternal();
      },

      selectionChanged(param) {
          var self = this;
          self.selectedRows = param.selectedRows;
          console.log("selection click", param.selectedRows);
          if(param.selectedRows.length == 100) {
            EventBus.$emit('clear-selection', false);
          } else {
            // EventBus.$emit('clear-all-flags', false);
          }
          self.isActivateStatus = true;
          self.isCloseStatus = false;
          param.selectedRows.forEach(element => {
            if(element.status == "Active") {
              self.isActivateStatus = false;
            } else {
            }
            if (element.status === "Closed"){
              self.isCloseStatus = true;
            }
          });

      },
      deleteDebtNote() {
          var self = this;
            var data = self.$refs['debtNoteListTable'].selectedRows;
            // for (var j = 0; j < data.length; j++) {
            //     if (data[j].status.toLowerCase() != 'entered'){
            //         self.$swal('','You can remove debt note with entered status only','info');
            //         return;
            //     }
            // }
          self.$swal({
                title: 'Are you sure that you want to delete this Debt Note?',
                type: 'info',
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                showCloseButton: false,
                showLoaderOnConfirm: true
          }).then((result) => {
              if (result.value) {
                // var data = self.$refs['debtNoteListTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(self.$refs['debtNoteListTable'].selectedRows[i].id);
                }
                console.log("list of IDS =", use);
                self.deleteDebtNoteCall(use);

                //
              } else {
                console.log("no");
              }
          });

      },
      deleteDebtNoteCall(ids) {

        var self = this;

        self.loading = true;
        $.ajax({
              url: process.env.ROOT_API + "/debtnote/delete",
              type: "POST",
              data: {
                ids: ids
              },
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  // console.log(data);
                  if (data.status == "success") {
                    self.cancelAll(true);
                    self.$swal('','Debt note deleted successfully','success');
                    self.loadList();
                  }else if(data.status == "warning"){
                    self.cancelAll(true);
                    self.$swal('','The following unit have not been deleted'+ "<br>" + data.content ,'info');
                    self.loadList();
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'debt-note-interest-status-change');
              }
          });

      },
      activateDebtNote() {
          var self = this;
          var data = self.$refs['debtNoteListTable'].selectedRows;
          var use = [];
          for (var i = 0; i < data.length; i++) {
            if (data[i].status.toLowerCase() != 'entered'){
                self.$swal('','You can active debt note with entered status only','info');
                return;
            }
            use.push(self.$refs['debtNoteListTable'].selectedRows[i].id);
          }
          console.log("list of IDS =", use);
          $.ajax({
              url: process.env.ROOT_API + "/debtnote/status_update",
              type: "POST",
              data: {
                status: 'Active',
                ids: use
              },
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  // console.log(data);
                  if (data.status == "success") {
                    self.cancelAll(true);
                    self.$swal('','Status Update successfully','success');

                    self.loadList();
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,false,'debt-note-interest-status-change');
              }
          });

      },
      reverseDebtNote: function () {
        var self = this;
        console.log('selected rows',self.selectedRows);
        if (self.selectedRows.length > 1){
          self.$swal({
            title: 'You can only reverse one debt note at a time.',
            type: 'error',
            showCancelButton: true,
            cancelButtonText: 'Ok',
            showCloseButton: true,
            showLoaderOnConfirm: true,
            showConfirmButton: false
          });
        }else{
          self.$swal({
            title: 'Are you sure to Reverse the Debt Note',
            type: 'info',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            showCloseButton: false,
            showLoaderOnConfirm: true
          }).then((result) => {
            if (result.value) {
              var debtNoteId = self.selectedRows[0].id;
              var path = window.location.pathname;
              var segments = path.split("/");
              self.loading = true;
              $.ajax({
                url: process.env.ROOT_API + "/debtnote/interest-for-reversal",
                type: "POST",
                data: {
                  debtNoteId: debtNoteId,
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                  self.loading = false;

                  if (data.status == "success") {
                    self.loading = false;
                    console.log("res =", data.content);
                    if(data.content.row.id > 0) {
                      self.$router.push("/debtpayment/reversal/view/" + data.content.row.id);
                    } else {
                      setTimeout(function () {
                        self.backScreen();
                      }, 1000);
                    }
                  }else{

                  }
                },
                error: function (jqXHR, exception) {
                  self.loading = false;
                  if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                  } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                      //clear previous data
                      localStorage.removeItem("user_obj");
                      localStorage.removeItem("tkn");
                      self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                  }
                }
              });
            } else {
              console.log("no");
            }
          });
        }
      },
      loadList() {

          var self = this;
          self.loading = true;
          var data = this.$refs['debtNoteListTable'].selectedRows;
          var selectedRows = [];

          for (var i = 0; i < data.length; i++) {
              selectedRows.push(self.$refs['debtNoteListTable'].selectedRows[i].id)
          }
          var fields = {
              page: self.serverParams.page,
              perPage: self.serverParams.perPage,
              filters: self.serverParams.columnFilters,
              sort: self.serverParams.sort,
              all:self.serverParams.selectedAll,
              selectedRows:selectedRows,
              action:self.action,
          };
          self.firstLoad = 1;
          $.ajax({
              url: process.env.ROOT_API + "/debtnote/list",
              type: "POST",
              data: fields,
              headers: this.ajxHeaders,
              dataType: "json",
              success: function (data) {
                  self.loading = false;
                  // console.log(data);
                  if (data.status == "success") {
                      if ( self.action == "export" ||  self.action == "export_queue") {
                          if ( data.code == "201" ) {
                              alert(data.message);
                          } else {
                              if ( self.action == "export" ) {
                                  self.excel = data.content.web;
                                  var save = document.createElement("a");
                                  save.href = self.excel;
                                  save.download = data.content.web;
                                  save.target = "_blank";

                                  document.body.appendChild(save);
                                  save.click();
                                  document.body.removeChild(save);

                              } else {

                                  self.batchProcess = 1;
                                  self.batchNum = data.content;
                              }
                          }
                          self.action = "list";
                          self.loadList();
                      } else{
                        console.log(data.content.row);
                          self.rows = data.content.row;
                          self.totalRecords = data.content.totalRecords;
                          self.filteredFlag = false;
                      }
                  }else{
                      self.rows = data.content.row;
                      self.totalRecords = data.content.totalRecords;
                      self.filteredFlag = false;
                  }
              },
              error: function (jqXHR, exception) {
                  self.loading = false;
                  if ( self.action == "delete" ) {
                      self.generateStatusCodeMessage(jqXHR,true,'rental-agreement-delete')
                  }else{
                      self.generateStatusCodeMessage(jqXHR,false,'rental-agreement-list')
                  }

              }
          });

      },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/payment/DebtNotesList.vue